module.exports = __webpack_public_path__ + "img/passport-3.bd86b0ec.png";